// remote-override.loader.ts
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of, timer } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { FirebaseService } from '@brightside-web/desktop/data-access/shared';
import { Environment } from '@micro-core/environment';
import { CopyOverrideInterface } from './copy-override.interface';
import { versionMatches } from './version-utils';

export class RemoteOverrideLoader implements TranslateLoader {
  constructor(
    private base: TranslateLoader,
    private analytics: FirebaseService,
    private env: Environment
  ) {}

  getTranslation(lang: string): Observable<any> {
    const base$ = this.base.getTranslation(lang);

    // Wait up to 500ms for RC defaults to populate
    const overrides$ = timer(100, 100).pipe(
      // check every 100ms up to ~500ms
      take(6),
      map(() => this.analytics.copyOverridesMapping() as CopyOverrideInterface[] || []),
      // stop when copyOverridesMapping() actually returns something
      switchMap(arr => (arr.length ? of(arr) : of(null))),
      take(1),
      map(arr => arr ?? []),
      map(arr => {
        return arr
          .filter(
            (item) =>
              item.locale === lang &&
              item.platforms?.includes('web') &&
              versionMatches(item.version, this.env.appVersion || '0.0.0')
          )
          .reduce<Record<string, string>>((acc, item) => {
            acc[item.key.toUpperCase()] = item.value;
            return acc;
          }, {});
      }
      )
    );

    return forkJoin([base$, overrides$]).pipe(
      map(([base, overrides]) => {
        const result = { ...base, ...overrides };
        return result;
      })
    );
  }
}
